<template lang="pug">
#customers-pages.base-page.grid-box.grid-col
    customerList.customer-list.scroll-y(
        v-model:selected-user="selectedUser"
        :slots="customers"
        @create-customer="handlePopup"
    )
    customerDetails.customer-view.scroll-y(
        v-if="selectedUser"
        v-model:selection="selectedUser"
        @close="selectedUser=undefined"
    )
    .customer-view(v-if="!selectedUser")
        .warning Loading...
        .loading-box
            .loading-circle

    NewCustomerPopup(
        v-if="showCreateUser"
        @update:show-poup="showCreateUser=false"
    )

</template>

<script lang="ts" setup>
import { ref, computed, watchEffect} from "vue";
import { DataInstance } from "@busy-human/gearbox";
import { Userspaces } from "@busy-human/k9-library";
import { useUserspace } from "@/store/useUsers";
import NewCustomerPopup from "../components/new-customer-popup.vue";
import customerList from "../components/customer-list.vue";
import customerDetails from "../components/customer-details.vue";

const userSpace = useUserspace();
const showCreateUser = ref(false);
// eslint-disable-next-line vue/no-side-effects-in-computed-properties
const customers = computed<DataInstance<Userspaces.Model>[]>(() => userSpace.asArray
	.sort((a,b) => {
		if(a?.name?.firstName && !b?.name?.firstName) return -1;
		else if(b?.name?.firstName && !a?.name?.firstName) return 1;
		else if(a?.name?.firstName && b?.name?.firstName) return a.name.firstName < b.name.firstName ? -1 : 1;
		else return a.email < b.email ? -1 : 1;
	}));
const handlePopup = ()=>{
	console.log("recieved emit");
	showCreateUser.value = !showCreateUser.value;
};

const selectedUser = ref<DataInstance<Userspaces.Model> | undefined>();

watchEffect(()=>{
	if(customers.value && customers.value[0]?.email?.length > 3){
		[selectedUser.value] = customers.value;
	}
});

</script>
<style lang="scss">
#customers-pages{
    position: relative;
    display: grid;
    grid-template-columns: 22rem 1fr;
    padding: 1rem 0 2rem;

    .customer-view,
    .customer-view-placeholder {
        position: relative;
        height: 100%;
    }

    .new-customer-popup{
        width:  100vw;
        height: 100vh;
    }
}
</style>